import {
    getSessionClientInformation,
    getSessionUserInformation,
} from "app/utils/utility.service";
import { getClientSetting } from "app/views/home-purchase/HomePurchaseStep3/homepurchase.service";
import { getClientUser } from "app/views/home-purchase/HomePurchaseStep3/homepurchase.service";
import { getMonthlyExpenses } from "app/views/home-purchase/HomePurchaseStep3/homepurchase.service";
import { InputNumber } from "primereact/inputnumber";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import "../Reports.scss";
import { Button } from "primereact/button";
import { getRentOwnedEstateRecords } from "app/utils/utility.service";
import { getSessionAgentInformation } from "app/utils/utility.service";

import ReportHeader from "../ReportHeader";
import { FormatAmount } from "app/utils/utility.service";
import BarChart from "./BarChart";
import Configuration from "./Configuration";
import HomeValueTable from "./HomeValueTable";
import LeftContent from "app/views/home-purchase/HomePurchaseStep3/LeftContent/LeftContent";
import { useMediaQuery } from "react-responsive";
import { calculateLoanValues } from "app/utils/utility.service";

export const ComponentToPrint = React.forwardRef((props, ref) => {
    const {
        loanData,
        expensesRecord,
        reportData,
        totalEquityList,
        totalHomeValue,
        appreciationList,
        labels,
        showMore,
        showButton,
        handleShowMore,
        userSettings
    } = props;
    const isDesktopOrLaptop = useMediaQuery({
        query: "(min-width: 1224px)",
      });
    const [basicData] = useState({
        labels: labels,
        datasets: [
            {
                label: "Loan Amount",
                data: loanData.every3Years.values,
                borderColor: "#2196F3",
                backgroundColor: "rgba(180, 225, 233, 0.6)", // Semi-transparent
                 
            },
            {
                label: "Total Home Value",
                data: totalHomeValue,
                borderColor: "#2196F3",
                backgroundColor: (context) => {
                    const ctx = context.chart.ctx;
                    const gradient = ctx.createLinearGradient(100, 0, 100, 500);
                    gradient.addColorStop(1, "rgba(33, 150, 243,1)");
                    gradient.addColorStop(0, "rgba(33, 150, 243,0)");
                    return gradient;
                  },
                 
            },
        ],
    });
    const [searchParams] = useSearchParams();
    const clientId = searchParams.get("clientid");
    const navigate = useNavigate();
    const [newReportData, setNewReportData] = useState([reportData]);
    const [lastReportData] = useState([reportData[reportData.length-1]]);
    useEffect(() => {
        if (reportData?.length > 0) {
            if (!showButton) {
                if (!showMore) {
                    setNewReportData([...reportData.slice(0, 4)]);
                }
                if (showMore) {
                    setNewReportData([...reportData]);
                }
            } else {
                setNewReportData([...reportData]);
            }
        }
    }, [showMore, showButton]);

    // let basicOptions = {
    //     maintainAspectRatio: false,
    //     scales: {
    //         x: {
    //             grid: {
    //                 display: false,
    //             },
    //         },
    //         y: {
    //             display: false,
    //             grid: {
    //                 display: false,
    //             },
    //         },
    //     },
    //     plugins: {
    //         legend: {
    //             display: false,
    //         },
    //         title: {
    //             display: true,
    //             text: "Avg interest by month (days)",
    //             padding: {
    //                 bottom: 30,
    //             },
    //             weight: "bold",
    //             color: "#00325c",
    //             font: {
    //                 size: 13,
    //             },
    //             align: "start",
    //         },
    //         datalabels: {
    //             display: true,
    //             color: "black",
    //             align: "end",
    //             padding: {
    //                 right: 2,
    //             },
    //             labels: {
    //                 padding: { top: 10 },
    //                 title: {
    //                     font: {
    //                         weight: "bold",
    //                     },
    //                 },
    //                 value: {
    //                     color: "green",
    //                 },
    //             },
    //             formatter: function (value) {
    //                 return "\n" + value;
    //             },
    //         },
    //     },
    // };

    return (
        <div ref={ref}>
            <div className="Reports content">
                {isDesktopOrLaptop && (
                  <div className="left">
                        <LeftContent />
                    </div>
                )}
                <div className="HomePrice right ml-4">
                <div className="linkCls pb-4 pt-4">
                  <a
                    href="javascript:;"
                    onClick={()=> navigate(`/home-purchase/step3/tab1`)}
                    className={`${
                        isDesktopOrLaptop
                            ? "mr-5"
                            : "mr-4"
                    }`}
                >
                    Go To Design View
                </a>
                </div>
                   
                  
                    {/* Configurable component goes here
                    <Configuration expensesRecord={expensesRecord} userSettings={userSettings} /> */}
                   

                    <div>
                        <BarChart data={basicData} />
                        {/* <Chart type="bar" data={basicData} options={basicOptions} /> */}
                    </div>
                    <div className="printSeparation"></div>
                    {/* Table data goes here */}
                    <HomeValueTable
                        reportData={newReportData}
                        showMore={showMore}
                        showButton={!showButton}
                        handleShowMore={handleShowMore}
                        lastData={lastReportData}
                    />
                </div>
            </div>

            <div className="printSeparation"></div>
        </div>
    );
});

const HomeValueProjection = () => {
    const agentValues = getSessionAgentInformation();
    const [searchParams] = useSearchParams();
    const componentRef = useRef(null);
    const clientId = searchParams.get("clientid");
    const [isLoading, setIsLoading] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const [loanData, setLoanData] = useState({ yearly: { labels: [], values: [] }, every3Years: { labels: [], values: [] } });
    let sessionValues =
        clientId && clientId !== "null"
            ? getSessionClientInformation()
            : getSessionUserInformation();
    const clientInfo = getSessionClientInformation();
    if (clientInfo) {
        sessionValues = clientInfo;
    }
    const [expensesRecord, setExpensesRecord] = useState(null);
    const [userRecord, setUserRecord] = useState(null);
    const [userSettings, setUserSettings] = useState(null);
    const navigate = useNavigate();
    const [isPrinting, setIsPrinting] = useState(false);
    const promiseResolveRef = useRef(null);
    const [graphRecords, setGraphRecords] = useState([]);

    useEffect(() => {
        if (isPrinting && promiseResolveRef.current) {
            // Resolves the Promise, letting `react-to-print` know that the DOM updates are completed
            promiseResolveRef.current();
        }
    }, [isPrinting]);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        onBeforeGetContent: () => {
            return new Promise((resolve) => {
                promiseResolveRef.current = resolve;
                setIsPrinting(true);
            });
        },
        onAfterPrint: () => {
            // Reset the Promise resolve so we can print again
            promiseResolveRef.current = null;
            setIsPrinting(false);
        },
    });

    const fetchUserExpenses = async () => {
        setIsLoading(true);
        const fetchedExpensesRecord = await getMonthlyExpenses({
            userId:
                clientId && clientId !== "null" ? clientId : sessionValues?.id,
        });
        if (fetchedExpensesRecord) {
            setExpensesRecord(fetchedExpensesRecord);
            setIsLoading(false);
            return;
        }
    };

    const fetchUserInformation = async () => {
        setIsLoading(true);
        const userId =
            clientId && clientId !== "null" ? clientId : sessionValues?.id;
        const fetchedRecord = await getClientUser(userId);
        if (fetchedRecord) {
            setUserRecord(fetchedRecord);
            setIsLoading(false);
            return;
        }
    };

    const fetchUserSettings = async () => {
        setIsLoading(true);
        const userId =
            clientId && clientId !== "null" ? clientId : sessionValues?.id;
        const fetchedRecord = await getClientSetting(userId);
        if (fetchedRecord) {
            setUserSettings(fetchedRecord);
            setIsLoading(false);
            return;
        }
    };

    const handleShowMore = () => {
        setShowMore(!showMore);
    };

    const getComponentToPrint = (showButton) => {
        let totalHomeValueElements = [];
        let totalHomeLabelElements = [];
        if (graphRecords?.totalHomeValue?.length > 0) {
            graphRecords?.totalHomeValue.forEach((element, index) => {
                // console.log("element",element);
                if (index === 0) {
                    totalHomeValueElements.push(Number(element).toFixed(0));
                } else {
                    if (index % 3 === 0) {
                        totalHomeValueElements.push(Number(element).toFixed(0));
                    }
                }
            });
            if (graphRecords?.labels?.length > 0) {
                graphRecords?.labels.forEach((element, index) => {
                    if (index === 0) {
                        totalHomeLabelElements.push(element);
                    } else {
                        if (index % 3 === 0) {
                            totalHomeLabelElements.push(element);
                        }
                    }
                });
            }
        }
        return (
            <ComponentToPrint
                loanData={loanData}
                expensesRecord={expensesRecord}
                reportData={graphRecords?.reportData}
                totalEquityList={graphRecords?.totalEquityList}
                totalHomeValue={totalHomeValueElements}
                appreciationList={graphRecords?.appreciationList}
                labels={totalHomeLabelElements}
                showMore={showMore}
                handleShowMore={handleShowMore}
                showButton={showButton}
                ref={componentRef}
                userSettings={userSettings}
            />
        );
    };

    useEffect(() => {
        fetchUserInformation();
        fetchUserExpenses();
        fetchUserSettings();
    }, []);

    useEffect(() => {
        if (userRecord && expensesRecord && userSettings) {
            setGraphRecords(
                getRentOwnedEstateRecords(
                    userRecord,
                    expensesRecord,
                    userSettings
                )
            );
        
        //Calculate loan values
        let loanValues = calculateLoanValues(expensesRecord?.mortgageExpenseRecord?.firstLoanPrincipalAmt,expensesRecord?.mortgageExpenseRecord?.firstLoanInterestRate,userSettings?.amortizationYears);
        let yearly = loanValues.yearly;
        let every3Years = loanValues.every3Years;
        // Update state once after calculations
        setLoanData({
            yearly: { labels: yearly.map(v => v[0]), values: yearly.map(v => Math.round(v[1] * 100) / 100) },
            every3Years: { labels: every3Years.map(v => v[0]), values: every3Years.map(v => Math.round(v[1] * 100) / 100) }
        });
    }
    }, [userRecord, expensesRecord, userSettings]);

    return (
        <Fragment>
            {/* <ReactToPrint
                trigger={() => <button>Print this out!</button>}
                content={() => componentRef.current}
            /> */}
            {!isLoading &&
            expensesRecord &&
            userRecord &&
            graphRecords?.totalEquityList?.length > 0 &&
            graphRecords?.appreciationList?.length > 0 &&
            graphRecords?.labels?.length > 0 ? (
                <Fragment>
                    {getComponentToPrint(isPrinting)}
                    <div style={{"width":"100%", "paddingLeft":"106rem"}}>
                    <Button
                        className="p-button-raised p-button-warning mr-2"
                        onClick={handlePrint}
                    >
                        Print Report
                    </Button>
                    <Button
                        label="Cancel"
                        className="p-button-raised p-button"
                        onClick={() => navigate(-1)}
                    />
                    </div>
                </Fragment>
            ) : (
                <p>Please store the data to print the report.</p>
            )}
        </Fragment>
    );
};

export default HomeValueProjection;
